<template>
  <div>
    <Layout1 v-if="item.layout === 1" :sortBy="this.sortBy" />
    <Layout2 v-if="item.layout === 2" />
  </div>
</template>

<script>
const Layout1 = () => import("./Layout1");
const Layout2 = () => import("./Layout2");
import { mapState } from "vuex";

export default {
  props: ['sortBy'],
  components: {
    Layout1,
    Layout2
  },
  computed: {
    ...mapState({
      venue_hire: state => state.ServiceMenu.venture_hire,
      branch_id: state => state.Branch.branch_id
    })
  },
  data: () => ({
    item: {
      layout: 1 // change this to developer
    }
  })
};
</script>

<style lang="scss" scoped></style>
